import { createSlice } from "@reduxjs/toolkit";
import {
  getUserDetails,
  updateCreatorDetails,
  updateBrandDetails,
} from "./userService";

// Initial state
const initialState = {
  userDetails: null,
  loading: false,
  error: null,
};

// User slice
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    clearUserErrors: (state) => {
      state.error = null;
    },
    clearUserData: (state) => {
      state.userDetails = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get User Details
    builder
      .addCase(getUserDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = action.payload.data;
      })
      .addCase(getUserDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Creator Details
      .addCase(updateCreatorDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCreatorDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = {
          ...state.userDetails,
          ...action.payload.data,
        };
      })
      .addCase(updateCreatorDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update Brand Details
      .addCase(updateBrandDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateBrandDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.userDetails = {
          ...state.userDetails,
          ...action.payload.data,
        };
      })
      .addCase(updateBrandDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearUserErrors, clearUserData } = userSlice.actions;
export default userSlice.reducer;
